window.SusucoWishlist = (function () {
  const STORAGE_KEY = 'susuco:wishlist';

  function getAll() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function has(handle) {
    return getAll().includes(handle);
  }

  function toggle(handle) {
    const items = getAll();
    const index = items.indexOf(handle);

    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push(handle);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('susuco:wishlist:change', { detail: { items } }));
    return items.includes(handle);
  }

  function remove(handle) {
    const items = getAll().filter((item) => item !== handle);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('susuco:wishlist:change', { detail: { items } }));
  }

  return { getAll, has, toggle, remove };
})();

if (!customElements.get('wishlist-heart')) {
  class WishlistHeart extends HTMLElement {
    connectedCallback() {
      this.handle = this.dataset.handle;
      this.button = this.querySelector('button');
      if (!this.button || !this.handle) return;

      this.onChange = this.render.bind(this);
      this.render();

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        const active = window.SusucoWishlist.toggle(this.handle);
        this.setState(active);
      });

      document.addEventListener('susuco:wishlist:change', this.onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('susuco:wishlist:change', this.onChange);
    }

    render() {
      this.setState(window.SusucoWishlist.has(this.handle));
    }

    setState(active) {
      this.classList.toggle('is-active', active);
      this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
      this.button.setAttribute('aria-label', active ? 'İstek listesinden çıkar' : 'İstek listesine ekle');
    }
  }

  customElements.define('wishlist-heart', WishlistHeart);
}
